const accountSelectionMethodOptions: { [key: string]: string } = {
  any: 'Any',
  online: 'Online',
  manual: 'Manual',
};

export default accountSelectionMethodOptions;
